/**
 * Created by Xuz on 2019/01/14.
 * xuz@live.cn
 * 终点节点
 */
import * as WFC from '../WFConstants'
import WFNode from '../WFNode'

class TBEndNode {
  constructor (workflow) {
    this.workflow = workflow
    this.$_c = this.workflow.parent.$_c
  }

  doMouseDown (event) {
    let el = this.workflow.getSelectedElement(event)
    if (el == null) {
      el = new WFNode(this.workflow, WFC.NODE_TYPE_END_NODE)
      el.create(event)
      this.workflow.setActiveElement(el, event)
    } else {
      this.workflow.setActiveElement(el, event)
    }
  }

  doMouseMove (event) {
    const el = this.workflow.getLastElement(event)
    el.onMove(event)
  }

  doMouseUp (event) {
    const el = this.workflow.getLastElement(event)
    if (el == null) {
      return
    }
    el.onUp(event)
  }

  doMouseDblClick (event) {
    const el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
    } else {
      if (el === this.workflow.getLastElement()) {
        el.onMouseDblClick(event)
      } else {
        this.workflow.setActiveElement(el, event)
      }
    }
  }

  getName () {
    return '终点'
  }

  getIcon () {
    return this.$_c + 'app/workflow/img/design/end.png'
  }
}

export default TBEndNode
